'use strict';

function NavigationBarController(meService, languageService, $navigation, $role, $location, $scope, $window, $filter) {
  var vm = this;

  vm.$onInit = $onInit;

  vm._retrieveUserFinished = _retrieveUserFinished;
  vm._retrieveUserFailed = _retrieveUserFailed;
  vm._locationChanged = _locationChanged;
  vm._refreshLanguages = _refreshLanguages;

  vm.getDisplayName = getDisplayName;
  vm.changeLanguage = changeLanguage;
  vm.getHelpKey = getHelpKey;
  vm.hasRole = _hasRole;
  vm.hasHelpText = hasHelpText;
  vm.showNavbar = function() {
    return $location.path() !== '/landing' && vm.user;
  };


  var helpTextLocations = [
    {
      locationKeys: ['performance-review'],
      key: 'invite.performance.helpText',
      blockedLocations: ['overview']
    },
    {
      locationKeys: ['performance-review', 'invite'],
      key: 'invite.performance.review.helpText'
    },
    {
      locationKeys: ['performance-review', 'basis'],
      key: 'invite.performance.basis.helpText'
    },
    {
      locationKeys: ['performance-review', 'questionnaire'],
      key: 'invite.performance.questionnaire.helpText',
      managerKey: 'invite.performance.questionnaire.helpText.manager'
    },
    {
      locationKeys: ['performance-review', 'distribution'],
      key: 'invite.performance.distribution.helpText'
    },
    {
      locationKeys: ['performance-review', 'overview'],
      key: 'invite.performance.overview.helpText'
    },
    {
      locationKeys: ['salary'],
      key: 'invite.salary.helpText',
      blockedLocations: ['overview']
    },
    {
      locationKeys: ['salary', 'invite'],
      key: 'invite.salary.invite.helpText'
    },
    {
      locationKeys: ['salary', 'basis'],
      key: 'invite.salary.basis.helpText'
    },
    {
      locationKeys: ['salary', 'questionnaire'],
      key: 'invite.salary.questionnaire.helpText',
      managerKey: 'invite.salary.questionnaire.helpText.manager'
    },
    {
      locationKeys: ['salary', 'overview'],
      key: 'invite.salary.overview.helpText'
    },
    {
      locationKeys: ['salary', 'distribution'],
      key: 'invite.salary.distribution.helpText'
    },
    {
      locationKeys: ['admin'],
      key: 'admin.helpText'
    }
  ];

  function $onInit() {
    // This prevents some "flickering" after login
    if ($location.path() === '/landing') {
      $window.location.href = '/v2/dashboard';
      return;
    }

    vm.user = vm.user || false;
    vm._refreshLanguages();
    vm.managerScope = false;

    $scope.$on('$locationChangeSuccess', vm._locationChanged);
    $scope.$on('$setManagerSCope', setManagerScope);

    return meService.retrieve()
      .then(vm._retrieveUserFinished);
  }

  function _retrieveUserFinished(response) {
    vm.user = response.data;
  }

  function _retrieveUserFailed() {
    vm.user = false;
  }

  function getDisplayName() {
    return (vm.user.first_name && vm.user.last_name) ? vm.user.first_name + ' ' + vm.user.last_name : vm.user.email;
  }

  function _locationChanged() {
    vm.items = $navigation.routes.map(function _byActiveRoute(route) {
      route.active = route.regexp.test($location.path());
      route.group = $role.translate(route.role);
      return route;
    });
  }

  function _refreshLanguages() {
    return languageService.list()
      .then(function (response) {
        vm.languages = response;
      });
  }

  function changeLanguage(language) {
    return languageService.update(language)
      .then(vm._refreshLanguages).then(function () {
        $window.location.reload();
      });
  }

  function getHelpKey() {
    var currentUrl = $location.path();
    var validLocations = helpTextLocations.filter(function (helpLocation) {
      return helpLocation.locationKeys.every(function (key) {
        return currentUrl.indexOf(key) > -1 && !isBlocked(helpLocation, currentUrl);
      });
    });
    validLocations.sort(function (a, b) {
      return b.locationKeys.length - a.locationKeys.length;
    });
    if (validLocations.length > 0) {
      if (isManagerScope() && validLocations[0].managerKey) {
        return validLocations[0].managerKey;
      }
      return validLocations[0].key;
    }
  }

  function isManagerScope() {
    return vm.managerScope;
  }

  function setManagerScope(event, data) {
    vm.managerScope = data;
  }

  function isBlocked(helpLocation, currentUrl) {
    if (!helpLocation.blockedLocations || helpLocation.blockedLocations.size === 0) {
      return false;
    }
    return helpLocation.blockedLocations.some(function (location) {
      return currentUrl.indexOf(location) > -1;
    });
  }


  function hasHelpText() {
    var key = vm.getHelpKey();
    if (!key) {
      return false;
    }
    var text = $filter('translate')(key);
    if (text.length !== key.length) {
      return true;
    }
    return false;
  }

  function _hasRole(role) {
    return vm.user.groups.map(function (group) {
      return group.name;
    }).some(function (groupName) {
      return groupName === role;
    });

  }
}

module.exports = NavigationBarController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/navigation-bar/navigation-bar.controller.js
 ** module id = 52
 ** module chunks = 0
 **/